import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';
import HowItWorksSteps from 'components/HowItWorksSteps';
import * as surveyActions from 'actions/surveyActions';
import { OWNER } from 'constants/users';
import './PreEngagementStyles.scss';

class PreEngagement extends Component {
    componentWillMount() {
        this.fetchData();
    }
    render() {
        return (
            <div className='fl-pre-engagement text-center'>
                <div className='pre-engagement-header-container'>
                    <h3>{i18n.t('motivator.thanks_for_finishing_your_intrinsic_motivation_survey') }</h3>
                    {this.props.respondent.get('userRole') !== OWNER && <p>{i18n.t('motivator.the_person_inviting_you_access_to_your_report')}</p>}
                </div>
                <HowItWorksSteps selectedStep={ 2 } />

                <p className='pre-engagement-message'>{i18n.t('motivator.in_step_2_you_will_take_a_short_engagement_survey') }</p>
                <Button className='fl-button' onClick={ this.handleClick }>{ i18n.t('motivator.Start_Survey') }</Button>
            </div>
        );
    }
    handleClick = async () => {
        await this.props.actions.goToSurveyPage(this.props.respondent.toJS());
    };

    fetchData = async () => {
        const { engagementSurveyToken } = this.props;
        await this.props.actions.getSurveyOptions(engagementSurveyToken);
        await this.props.actions.getSurvey('engagement/questions', engagementSurveyToken);
    }
}

PreEngagement.propTypes = {
    respondent: PropTypes.object,
    engagementSurveyToken: PropTypes.string
};

PreEngagement.defaultProps = {
    respondent: {}
};

const mapStateToProps = state => ({
    engagementSurveyToken: state.respondentNameReducer.get('engagementSurveyToken'),
    respondent: state.respondentNameReducer
});
const mapActionsToProps = dispatch => ({
    actions: bindActionCreators(surveyActions, dispatch)
});
export default withTranslation()(connect(mapStateToProps, mapActionsToProps)(PreEngagement));
